import { render, staticRenderFns } from "./superdocument-audit.vue?vue&type=template&id=580424b5&scoped=true&"
import script from "./superdocument-audit.vue?vue&type=script&lang=js&"
export * from "./superdocument-audit.vue?vue&type=script&lang=js&"
import style0 from "./superdocument-audit.vue?vue&type=style&index=0&id=580424b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580424b5",
  null
  
)

export default component.exports